// "information.<key>" 로 부르는 문구. 값에 {name} 을 두면 t(key, { name }) 로 채운다.
const information = {
  ko: {
    // Farm 카드
    "farm.title": "농장",
    "farm.cropName": "작물명",
    "farm.size": "농장 면적",
    "farm.totalCells": "총 셀 수",
    "farm.cellsValue": "{count}칸",

    // Pole / Cube 카드
    "pole.smartPole": "스마트 폴",
    "pole.solarCube": "솔라 큐브",
    "pole.offline": "오프라인",
    "pole.operatingStatus": "동작 상태",
    "pole.normal": "정상",
    "pole.abnormal": "이상",
    "pole.battery": "배터리",

    // 큐브 여러 대 카드. 엣지만 구성은 제목 옆에 "개별 운영" 배지(줄에 역할 배지가 없어서), 오른쪽은 "N대 중 M대 정상".
    "cube.titleCount": "솔라 큐브 {count}대",
    "cube.okCount": "{total}대 중 {ok}대 정상",
    "cube.edgeOnly": "개별 운영 · 전력 공유 없음",
    // 연결된 에너지 장치가 없는 농장
    "device.none.title": "에너지 장치",
    "device.none.body": "연결된 에너지 장치가 없습니다. 관리자에게 장비 연결을 요청해 주세요.",
    // 펼친 줄의 역할 · 시리얼 행. 역할은 fog 구성에서만 보인다.
    "device.role": "역할",
    "device.serial": "시리얼",
    "role.FOG": "fog",
    "role.EDGE": "edge",
    "badge.FOG": "FOG",
    "badge.EDGE": "EDGE",

    // Drone 카드
    "drone.title": "드론",
    "drone.offline": "오프라인",
    "drone.powerStatus": "전원 상태",
    "drone.power.on": "ON",
    "drone.power.off": "OFF",
    "drone.battery": "배터리",
    "drone.gpsSignalStatus": "GPS 신호 상태",

    // 접힌 카드 한 줄 요약
    "summary.disconnected": "연결 끊김 · 점검 필요",
    "summary.operatingNormal": "정상 작동",
    "summary.operatingAbnormal": "동작 이상",
    "summary.battery": "배터리 {percent}%",
    "summary.powerOff": "전원 OFF",
    "summary.signal": "신호 {status}",
    "summary.signalGood": "양호",
    // heartbeat 가 아직 없는 장치: 연결 여부 · 배터리를 모른다
    "summary.unknown": "상태 확인 전",

    // GPS 측위 등급·토스트
    "gps.quality.Good": "양호",
    "gps.quality.Poor": "불량",
    "gps.quality.Unknown": "알 수 없음",
    "gps.qualityWithLevel": "{quality} ({level})",
    "gps.needsCheck": "GPS가 3D fix 상태입니다. GPS 상태를 확인하세요.",
  },
  en: {
    // Farm card
    "farm.title": "Farm",
    "farm.cropName": "Crop name",
    "farm.size": "Farm Size",
    "farm.totalCells": "Total Cells",
    "farm.cellsValue": (p) => `${p.count} ${p.count === 1 ? "cell" : "cells"}`,

    // Pole / Cube card
    "pole.smartPole": "Smart Pole",
    "pole.solarCube": "Solar Cube",
    "pole.offline": "Offline",
    "pole.operatingStatus": "Operating Status",
    "pole.normal": "Normal",
    "pole.abnormal": "Abnormal",
    "pole.battery": "Battery",

    // Multi-cube card
    "cube.titleCount": (p) => `Solar Cube${p.count === 1 ? "" : "s"} (${p.count})`,
    "cube.okCount": "{ok} of {total} operating",
    "cube.edgeOnly": "Standalone · no power sharing",
    "device.none.title": "Energy Devices",
    "device.none.body": "No energy device is connected to this farm. Ask an administrator to connect one.",
    "device.role": "Role",
    "device.serial": "Serial",
    "role.FOG": "fog",
    "role.EDGE": "edge",
    "badge.FOG": "FOG",
    "badge.EDGE": "EDGE",

    // Drone card
    "drone.title": "Drone",
    "drone.offline": "Offline",
    "drone.powerStatus": "Power Status",
    "drone.power.on": "ON",
    "drone.power.off": "OFF",
    "drone.battery": "Battery",
    "drone.gpsSignalStatus": "GPS Signal Status",

    // Collapsed card one-line summary
    "summary.disconnected": "Disconnected · Needs check",
    "summary.operatingNormal": "Operating normally",
    "summary.operatingAbnormal": "Malfunction",
    "summary.battery": "Battery {percent}%",
    "summary.powerOff": "Power OFF",
    "summary.signal": "Signal {status}",
    "summary.signalGood": "Good",
    "summary.unknown": "Status pending",

    // GPS fix quality and toast
    "gps.quality.Good": "Good",
    "gps.quality.Poor": "Poor",
    "gps.quality.Unknown": "Unknown",
    "gps.qualityWithLevel": "{quality} ({level})",
    "gps.needsCheck": "GPS is at 3D fix. Please check the GPS status.",
  },
};

export default information;
